// extracted by mini-css-extract-plugin
export var bodyRow = "_f0-d";
export var cardColumns = "_f0-e";
export var ellipsesOverflow = "_f0-2";
export var flatBottomCorners = "_f0-3";
export var flatTopCorners = "_f0-4";
export var headerActionsDropdown = "_f0-f";
export var headerBottomRow = "_f0-c";
export var headerTopRow = "_f0-b";
export var orderDetailsWrapper = "_f0-0";
export var orderInfoContainer = "_f0-1";
export var productDetails = "_f0-9";
export var productImage = "_f0-5";
export var responsiveTable = "_f0-8";
export var shipmentContainer = "_f0-a";
export var tableBottomLeft = "_f0-6";
export var tableBottomRight = "_f0-7";
export var trackingLink = "_f0-g";